<mat-card appearance="outlined" class="se-flatpanel">

  <mat-card-header class="estensa-card-header" *ngIf="title">
    <mat-card-title class='estensa-card-title'>
      <h4 class="mat-h4 estensa-mat-h4">{{title}}</h4>
    </mat-card-title>
    <div>
      <ng-content select="[additional]"></ng-content>
    </div>
  </mat-card-header>

  <mat-card-content [ngClass]="{'se-flatpanel-content-internal':!!isInternalPanel, 'se-flatpanel-content':!!!isInternalPanel}">
    <ng-content></ng-content>
  </mat-card-content>
</mat-card>